export default "__VITE_ASSET__C0r6uZCx__"